const checkItemHasPrice = currentPrice => {
  return currentPrice && !!parseFloat(currentPrice);
};

export default checkItemHasPrice;
